module.exports = __webpack_public_path__ + "static/media/select-user-image.b00a97a3.svg";